<template>
  <div class="behaviorRoot">
    <input type="hidden" name="_token" :value="csrf" />
    <input v-if="this.editing" type="hidden" name="_method" value="PUT" />

    <div class="row px-3">
      <div v-for="(column, indexC) in columns" v-bind:key="indexC" class="col-12 col-md-4 col-lg-4 mb-2">
        <div class="card p-2 border-card shadow">
          <p class="text-primary">{{ column }}</p>
          <p class="text-right h3">
            {{ totalsSum[indexC] }}
          </p>
        </div>
      </div>
    </div>

    <div class="form-group ml-2">
      <button type="button" class="btn btn--blue" @click="onUpdateBehaviorsIndicators()">
        <span v-if="plotVisible">{{
          __("views.Employee.charts.hideGraphs")
        }}</span>
        <span v-else>{{ __("views.Employee.charts.showGraphs") }}</span>
      </button>

      <div class="row" v-show="plotVisible">
        <div class="col-12 col-md-7 col-lg-7">
          <horizontal-bar-pnp :ref="'horizontal_bar_pnp_' + question_survey_id" :range="{ min: 0, max: 100 }"
            :step_size="10" :title_text="this.title_skills_graph"></horizontal-bar-pnp>
        </div>

        <div class="col-12 col-md-5 col-lg-5">
          <radar-pnp :ref="'radar_pnp_' + question_survey_id" :range="{ min: 0, max: 100 }"
            :title_text="this.title_values_graph"></radar-pnp>
        </div>
      </div>
    </div>

    <div class="row px-4 my-3">
      <div class="col-12">
        <button class="btn btn--blue" @click="hideAll" type="button">
          {{ __("views.pnpQuestion.hideAll") }}
        </button>
        <button class="btn btn--blue" @click="showAll" type="button">
          {{ __("views.pnpQuestion.openAll") }}
        </button>
      </div>
    </div>
    <div class="mb-2 px-4" v-for="(skill, indexS) in skills_indicator" :key="indexS">
      <button class="btn w-100 justify-content-between mb-2" type="button" @click="toggle(indexS)">
        {{ skill.name }}
        <div>
          <button type="button" v-if="skill.note !== ''" class="btn bg-transparent text-info"
            @click.stop="openNote(skill.name,skill.note)">
            <span style="text-decoration: underline; color: white;">{{ __("misc.show") }} {{
              __("views.Duties.description") }}</span>
          </button>
          <i :ref="'chevron' + indexS" class="fas fa-chevron-up"></i>
        </div>
      </button>

      <div :ref="`behavior${indexS}`">
        <div class="table--custom w-100 mx-0">
          <div class="single--row single--row-head single--row-head--mini">
            <div class="row">
              <div class="col-lg-9 col-md-9 col-12">
                <div class="single--row-info">
                  {{ title_indicators }}
                </div>
              </div>
              <div class="col-lg-1 col-md-1 col-12" v-for="(column, indexC) in columns" :key="indexC">
                <div class="single--row-info">
                  {{ column }}
                </div>
              </div>
            </div>
          </div>

          <div class="single--row single--row-input">
            <div class="single--row-input-content" v-for="(indicator, indexI) in skill.indicators" :key="indexI">
              <div class="row">
                <div class="col-lg-9 col-md-9 col-12">
                  <div class="single--row-info">
                    &nbsp; &nbsp; &nbsp;{{ indicator.name }}
                  </div>
                </div>
                <div class="col-lg-1 col-md-1 col-12" v-for="(column, indexC) in columns" :key="indexC">
                  <div style="padding-right: 10px; padding-left: 10px;" class="single--row-info">
                    <input v-if="column_permission[indexC]['permission'] > 1" type="number" :data-skill="indexS"
                      :data-behaviors_indicator="indexI" :data-column="indexC" :class="'form-control behaviorsIndicator ' +
                        column_permission[indexC]['classRequired']
                        " @blur="checkIndicatorRange" :name="'question[' +
    question_survey_id +
    '][' +
    indexS +
    '][' +
    indexI +
    '][' +
    indexC +
    ']'
    " :value="indicatorBehaviorsValues[indexI][indexC]" :min="range_value['min']"
                      :max="range_value['max']" />

                    <label v-else class="mx-auto d-block"> {{ values[indexI][indexC] }} </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br /><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function ctrl_validation_cell_behaviors(value_str, min, max) {
  if (value_str.length === 0 || value_str === "") {
    return true;
  }
  let value = parseInt(value_str);

  return !(isNaN(value) || value < min || value > max);
}

export default {
  created() {
    this.skillsTable = this.skills_zeros;
    this.valuesTable = this.values_zeros;
    this.totalsSum = this.totals_zeros;
    this.indicatorBehaviorsValues = this.values;
  },
  mounted() {
    this.onUpdateBehaviorsIndicators();
  },

  props: {
    column_permission: {
      type: Object,
      required: true,
    },

    range_value: {
      type: Object,
      required: true,
    },

    skills_indicator: {
      type: Object,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: false,
    },
    columns: {
      type: Object,
      required: true,
    },
    columns_color: {
      type: Object,
      required: true,
    },
    skills_zeros: {
      type: Object,
      required: true,
    },
    values_zeros: {
      type: Object,
      required: true,
    },
    totals_zeros: {
      type: Object,
      required: true,
    },

    values: {
      type: Object,
      required: true,
    },
    data_route_behaviors: {
      type: String,
      required: true,
    },

    title_skills_graph: {
      type: String,
      required: false,
    },
    title_values_graph: {
      type: String,
      required: false,
      default: "SS",
    },
    title_indicators: {
      type: String,
      required: false,
      default: "SS",
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      printed: false,
      test: 1,
      colMdFact: 7,
      colMdPresAver: 2,
      summary: [],
      skillsTable: [],
      valuesTable: [],
      totalsSum: [],
      indicatorBehaviorsValues: {},
      activeTab: null,
      //default
      plotVisible: true,
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    toggle(index) {
      this.$refs[`behavior${index}`][0].classList.toggle("d-none");
      this.$refs[`chevron${index}`][0].classList.toggle("fa-rotate-180");
    },
    hideAll() {
      let refs = this.$refs;
      console.clear();
      console.log(refs);
      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("behavior"),
      );
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron"),
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("fa-rotate-180");
      });
    },
    showAll() {
      let refs = this.$refs;
      console.clear();
      console.log(refs);
      const collapseRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("behavior"),
      );
      const chevronRefs = Object.keys(this.$refs).filter((ref) =>
        ref.includes("chevron"),
      );
      collapseRefs.forEach((ref) => {
        this.$refs[ref][0].classList.remove("d-none");
      });
      chevronRefs.forEach((ref) => {
        this.$refs[ref][0].classList.add("fa-rotate-180");
      });
    },
    openNote(name,note) {
      Vue.swal.fire({
        title: name,
        text: note,
      });
    },
    mountedDelayed() {
      this.onUpdateBehaviorsIndicators();
    },
    //function check if number and if number is in range
    checkIndicatorRange(event) {
      let skill = parseInt(event.target.getAttribute("data-skill"));

      if (
        !ctrl_validation_cell_behaviors(
          event.target.value,
          this.range_value.min,
          this.range_value.max,
        )
      ) {
        event.target.value = null;

        Vue.$toast.open({
          message: "Incorrected value!",
          type: "warning",
          position: "top-left",
        });

        return false;
      }
      this.indicatorBehaviorsValues[
        event.target.getAttribute("data-behaviors_indicator")
      ][event.target.getAttribute("data-column")] = event.target.value;
      this.onUpdateBehaviorsIndicators();
    },

    onUpdateBehaviorsIndicators() {
      let dataBehaviors = {
        indicators: this.indicatorBehaviorsValues,
        columns: this.columns,
        question_survey_id: this.question_survey_id,
        columns_color: this.columns_color,
        max_indicator: this.range_value.max,
        min_indicator: this.range_value.min,
        empty_values: this.empty_values,
      };
      this.plotVisible = !this.plotVisible;
      axios
        .post(decodeURI(this.data_route_behaviors), dataBehaviors)
        .then((response) => {
          this.skillsTable = response.data.skills;
          this.valuesTable = response.data.values;
          this.totalsSum = response.data.totals;

          this.$refs[
            "horizontal_bar_pnp_" + this.question_survey_id
          ].drawBarsGraph(response.data.horizontalGraphSettings);
          this.$refs["radar_pnp_" + this.question_survey_id].drawRadarGraph(
            response.data.radarGraphSettings,
          );
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
};
</script>

<style>

.swal2-title{
  margin-top:20px !important
}
.bg-transparent {
  background-color: transparent !important;
  box-shadow: none !important;
}

.border-card {
  border: none !important;
  border-left: 5px solid #1767a2 !important;
}
</style>
